import React, { Component } from 'react';
import ProgressSVG from './ProgressSvg';
import { fromJS } from 'immutable';
import anime from 'animejs';
import classNames from 'classnames';
import { debounce, every } from 'underscore';
import Icon from './SvgIcon';
import './Navigation.css';

const IconChecked = (readed) => {
  if(readed === 1){
    return <Icon name="skd-checked" color="#069AFF" size={32} />
  }else if(readed === 2){
    // quiz 正解
    return <Icon name="skd-passed" color="#069AFF" size={32} />
  }else if(readed === 3){
    // 不正解
    return <Icon name="skd-failed" color="#777" size={32} />
  }else{
    return null
  }
}

const parentIconChecked = (childarr,readedarr) => {
  const readed = every(childarr, (num) => {
      if(typeof num === 'object'){
        return every(num, (id) => {
          return readedarr[id-1] > 0;
        });
      }
      return readedarr[num-1] > 0;
    })
  if(readed){
    return <Icon name="skd-checked" color="#069AFF" size={32} />
  }else{
    return null;
  }
}

const matchedSearch = (listid, arr) => {
  if(arr.length > 0){
    return arr.some((id) => {
      return listid === id;
    });
  }
  return false;
}

const matchPlayingParent = (list, now) => {
  let _bool = false;
  if(typeof list === 'object'){
    _bool = list.some((cid) => {
      if(typeof cid === 'object'){
        return cid.some((id) => {
          return now + 1 === id;
        });
      }
      return now + 1 === cid;
    });
  }
  return _bool;
}

const nowplayingParent = (list, now) =>{
  const _bool = matchPlayingParent(list, now);
  return classNames({
    "now" : _bool,
    "has-children" : true
  })
}

const nowplaying = (id,now,parent=false) => {
  return classNames({
    "now" : now + 1 === id,
    "has-children" : parent
  })
}
const searchChecked = (listid, now, searcharr) => {
  let ismatch = matchedSearch(listid, searcharr);
  return classNames({
    "now" : now + 1 === listid,
    "hidden": !ismatch
  })
}

class ExChild extends Component {
  constructor(props){
    super(props);
    this.state = {
      isOpen: true
    }
    this.toggleList = this.toggleList.bind(this);
    this.checkChildShow = this.checkChildShow.bind(this);
    this.searchChildShow = this.searchChildShow.bind(this);
  }
  componentWillReceiveProps(nextProps){
    if(nextProps.searching){
      this.setState({
        isOpen:true
      });
    }else{
      this.setState({
        isOpen:false
      });
    }
  }
  toggleList(){
    let _isopen = !this.state.isOpen;
    this.setState({
      isOpen: _isopen
    });
    this.props.init();
  }
  checkChildShow(){
    //子供が非表示だったら、

    return classNames({
      "has-children" : true,
      "now": matchPlayingParent(this.props.listnum,this.props.id),
      "hidden": this.searchChildShow()
    })
  }
  searchChildShow(){
    //検索したときは、フォルダは開く
    const ChildMatch = this.props.listnum.filter(list => {
      return matchedSearch(list,this.props.search)
    });
    return ChildMatch.length === 0;
  }
  render() {
    let exname = `${this.props.groupname}-${this.props.cid}`;
    let childShow = this.props.child.childhidden ? <a onClick={(e) => {e.preventDefault(); this.props.changePage(document.getElementById(`click${this.props.listnum[0]}`))}} href="#" ><Icon name={"skd-video"} color="#fff" size={32} />{parentIconChecked(this.props.listnum, this.props.suspend)}{ this.props.child.title }</a> : <div><input type="checkbox" name={exname} id={exname} onChange={this.toggleList} /><label htmlFor={exname}><Icon name={this.state.isOpen ? "skd-folder-opened" : "skd-folder-closed"} color="#fff" size={22} /><Icon name="skd-arrow" color="#fff" size={22} />{this.props.child.title}</label></div>;
    return  (
      <li key={exname} className={this.props.searching ? this.checkChildShow(): nowplayingParent(this.props.listnum,this.props.id)}>
        {
          childShow
        }
          <ul>
            {
              this.props.child.contents.map((exchild, exid) => {
                // console.log(indexCount, `${exname}-${exid}`)

                return  <li className={this.props.searching ? searchChecked(this.props.listnum[exid], this.props.id, this.props.search):nowplaying(this.props.listnum[exid],this.props.id)} key={`${exname}-${exid}`}><a onClick={(e) => {e.preventDefault(); this.props.changePage(e.currentTarget)}} href="#" id={`click${this.props.listnum[exid]}`} ><Icon name={`skd-${exchild.type}`} color="#fff" size={32} />{IconChecked(this.props.suspend[this.props.listnum[exid]-1])}{ exchild.title }</a></li>
              })
            }
          </ul>
      </li>
    )
  }
}

class NavigationItem extends Component {
  constructor(props){
    super(props);
    this.state = {
      isOpen: false,
      id: props.id
    }
    this.toggleList = this.toggleList.bind(this);
    this.checkChildShow = this.checkChildShow.bind(this);
    this.searchChildShow = this.searchChildShow.bind(this);
  }
  componentDidMount(){

  }

  componentWillReceiveProps(nextProps){

    if(this.props.searching !== nextProps.searching){
      this.setState({
        isOpen:nextProps.searching
      });
    }
  }

  toggleList(){
    let _isopen = !this.state.isOpen;
    this.setState({
      isOpen: _isopen
    });
    this.props.init();
  }
  openList(){
    this.setState({
      isOpen:true
    });
  }
  checkChildShow(){
    //子供が非表示だったら、
    return classNames({
      "has-children" : true,
      "now": matchPlayingParent(this.props.total, this.props.id),
      "hidden": this.searchChildShow()
    })
  }
  searchChildShow(){
    // console.log(this.props.search);
    //検索したときは、フォルダは開く
    const ChildMatch = this.props.total.filter(list => {
      if(typeof list === "object"){
        return list.some(num => {
          return this.props.search.length>0 ? matchedSearch(num,this.props.search):false
        })
      }
      return this.props.search.length > 0 ? matchedSearch(list,this.props.search):false
    })
    return ChildMatch.length === 0;
  }
  render() {
    let listnum = 0;
    if(this.props.parent.contents){
      let groupname = `group-${this.props.index}`;
      return (
        <li key={groupname} className={this.props.searching ? this.checkChildShow(): nowplayingParent(this.props.total, this.props.id)}>
          <input type="checkbox" name={groupname} id={groupname} onChange={this.toggleList} checked={this.state.isOpen}/>
          <label htmlFor={groupname}><Icon name={this.state.isOpen ? "skd-folder-opened" : "skd-folder-closed"} color="#fff" size={22} /><Icon name="skd-arrow" color="#fff" size={22} />{parentIconChecked(this.props.total, this.props.suspend)}{this.props.parent.title}</label>
            <ul>
            {
              this.props.parent.contents.map((child,cid) => {
                if(child.contents){
                  listnum = this.props.total[cid]
                  //  console.log(listnum, `${groupname}-${cid}`)
                  return <ExChild key={`${groupname}-${cid}`} id={this.props.id} child={child} groupname={groupname} gid={this.props.index} cid={cid} changePage={this.props.changePage} suspend={this.props.suspend} init={this.props.init}
                  listnum={listnum}
                  search={this.props.search} searching={this.props.searching}/>
                }else{
                  listnum = this.props.total[cid];
                  // console.log(listnum, `${groupname}-${cid}`)
                  return  <li className={this.props.searching ? searchChecked(listnum, this.props.id, this.props.search):nowplaying(listnum, this.props.id)} key={`${groupname}-${cid}`}><a onClick={(e) => {e.preventDefault(); this.props.changePage(e.currentTarget)}} href="#" id={`click${listnum}`} ><Icon name={`skd-${child.type}`} color="#fff" size={32} />{IconChecked(this.props.suspend[listnum - 1])}{child.title}</a></li>
                }
              })
            }
            </ul>
        </li>)
    } else {
      listnum = this.props.total;
      return (<li className={this.props.searching ? searchChecked(listnum, this.props.id, this.props.search):nowplaying(listnum, this.props.id) }><a onClick={(e) => {e.preventDefault(); this.props.changePage(e.currentTarget)}} href="#" id={`click${listnum}`} ><Icon name={`skd-${this.props.parent.type}`} color="#fff" size={32} />{this.props.parent.title}{IconChecked(this.props.suspend[listnum - 1])}</a></li>)
    }
  }
}


class Navigation extends Component {
  constructor(props){
    super(props);
    this.state = {
      isRender: true,
      isSearch: false,
      searchtext: "",
      data: fromJS(props.data),
      searchArr: props.searchArr,
      searchArrText:[],
      searched: []
    }
    this.rerender = this.rerender.bind(this);
    this.handleSearch = this.handleSearch.bind(this);
    this.hoverClose = this.hoverClose.bind(this);
  }
  componentDidMount(){
    this.refs.myinput.value = "";
    this.handleSearch();
    //再開場所まで移動する処理削除
    /*
    if(this.props.id > 0){
      setTimeout(()=>{
        const initContent = document.querySelector('.Navigation-item li.now');
        const dom = document.querySelector('.Navigation-item');
        dom.scrollTop = initContent.offsetTop - 24;
        // console.log(initContent.offsetTop);
      },1500);
    }*/
    anime({
      targets: '.Navigation',
      translateX: '100%',
      duration: 0,
      easing: 'easeOutExpo'
    });
  }
  componentWillReceiveProps(nextProps){
    if(nextProps.isMenu){
      anime({
        targets: '.Navigation',
        translateX: 0,
        duration: 450,
        easing: 'easeOutExpo'
      });
    }else{
      anime({
        targets: '.Navigation',
        translateX: '100%',
        duration: 450,
        easing: 'easeOutExpo'
      });
    }
  }
  handleSearch(){
    const val = this.refs.myinput.value;
    if(val === ""){
      this.setState({
        searched: [],
        searchArrText:[],
        searchtext: val,
        isSearch: false
      })
      return;
    }
    const lines_arr = [];
    const lines = this.state.searchArr.filter((list, index) =>{
        if(!list){
          return true;
        }
        const isMatch = list.some((caption) => {
          if(val === ""){
            return true;
          }
          if(typeof caption === "string"){
            // console.log(caption, val, caption.indexOf(val) !== -1);
            return caption.indexOf(val) !== -1;
          }
          return caption.text.indexOf(val) !== -1;
        });
        if(isMatch){
          lines_arr.push(index+1);
        }
        return isMatch;
      });
      this.setState({
        searched: lines_arr,
        searchArrText: lines,
        searchtext: val,
        isSearch: true
      })
  }

  searchReset(){
    this.setState({
      isSearch: false
    })
  }

  rerender(){
    const dom = document.querySelector('.Navigation');
    dom.scrollTop = 0;
    // this.searchReset();
  }
  hoverClose(bool){
    if(bool){

   }else{

   }
  }
  render() {
    const tmp = this.props.data[0].contents.map((parent,index) =>
      <NavigationItem parent={parent} index={index} key={index} id={this.props.id} changePage={this.props.changePage} suspend={this.props.suspend} init={this.rerender} total={this.props.indexDataNum[index]} search={this.state.searched} searching={this.state.isSearch} searchtext={this.state.searchtext}/>
    );
    const circleRadius = 48;
    const circleR = 2 * Math.PI * circleRadius;
    const NowProgress = circleR * (1 - ((this.props.total - this.props.restNum)/this.props.total));
    let indexListClass = "Navigation-item is-scroll"
    /*if(this.state.isSearch){
      indexListClass = "Navigation-item"
    }*/

    return (
        <div className="Navigation">
            <header>
              <a className="cd-close-nav" href="#0" onMouseOver={(e)=>{e.preventDefault(); this.hoverClose(true);}} onMouseLeave={(e)=>{e.preventDefault(); this.hoverClose(false);}} onClick={(e) => {e.preventDefault(); this.props.toggleNav();}}><Icon name="skd-failed" color="#fff" size={36} /></a>
              <ProgressSVG circleRadius={circleRadius} circleR={circleR} NowProgress={NowProgress} restNum={this.props.restNum} />
              <div className="Navigation-search">
                <input className="search-box" placeholder="検索..." defaultValue="" ref="myinput" onChange={this.handleSearch}/>
              </div>
            </header>
            <div className={indexListClass}>
              <ul className="cd-accordion-menu">
                {tmp}
              </ul>
            </div>
        </div>
      );

  }
}

export default Navigation;



// WEBPACK FOOTER //
// ./src/Navigation.js